import {AppTourService} from '../../services/app-tour/app-tour.service';
import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {Select, Store} from '@ngxs/store';
import {CalorieTrackingNamespace, MealPlanBuilderAction, MealPlanBuilderState} from '../../models/meal-plan-builder';
import {firstValueFrom, Observable} from 'rxjs';
import {ICalorieTracking} from '../../models/meal-plans';
import {takeWhile} from 'rxjs/operators';

@Component({
  selector: 'app-custom-calorie-tracking',
  templateUrl: './custom-calorie-tracking.component.html',
  styleUrls: ['./custom-calorie-tracking.component.scss']
})
export class CustomCalorieTrackingComponent implements OnInit, OnDestroy, OnChanges {
  @Select(MealPlanBuilderState.getCalorieTracking) calorieTracking$: Observable<Partial<CalorieTrackingNamespace.ICalorieTracking> | null>;

  @Input() trackingValue: 'deficit' | 'surplus' = 'deficit';
  @Input() calories = 0;
  @Input() mealPlanCalories = 0;
  @Input() goalValue = 0;
  @Input() disabled = false;

  @Output() changeCalories: EventEmitter<Partial<ICalorieTracking>> = new EventEmitter();
  @Output() withoutData: EventEmitter<string> = new EventEmitter();

  activeObservables: boolean;
  measurementType: CalorieTrackingNamespace.MeasurementType = null;

  constructor(
    private store: Store,
    public appTourService: AppTourService,
  ) { }

  formatterKcal = (value: number | null): string => {
    if (!value) return `${0} kcal`;

    return `${Number(value.toFixed(2))} kcal`;
  }

  parserKcal = (value: string): string => value.replace(' kcal', '');

  ngOnInit(): void {
    this.initValues();
    this.initValuesHttp().then();
    this.listeners();
  }

  private initValues(): void {
    this.measurementType = 'custom';
    this.activeObservables = true;
  }

  private listeners(): void {
    this.calorieTracking$.pipe(takeWhile(() => this.activeObservables)).subscribe({
      next: (calorieTracking: Partial<CalorieTrackingNamespace.ICalorieTracking> | null): void => {
        if (!calorieTracking) {
          return;
        }

        this.calories = calorieTracking.calories;
        this.goalValue = calorieTracking.calories;
        this.trackingValue = calorieTracking.trackingType;
        this.measurementType = calorieTracking.measurementType ?? 'custom';
        if (!this.goalValue) {
          this.withoutData.emit('Para realizar el seguimiento de calorías es requerido ingresar la meta.');
        }
        this.calorieTrackingEmitted();
      }
    });

    this.appTourService.events.pipe(takeWhile(() => this.activeObservables)).subscribe({
      next: (event: string) => {
        switch (event) {
          case 'setCaloriesGoal': {
            this.goalValue = 1900;
            this.onChange();
          }
        }
      }
    });
  }

  async initValuesHttp(): Promise<void> {
  }

  async onChange(): Promise<void> {
    this.calorieTrackingEmitted();
    if (this.measurementType !== null) {
      await firstValueFrom(
        this.store.dispatch(new MealPlanBuilderAction.PatchCalorieTracking({
          measurementType: this.measurementType,
          calories: this.goalValue,
          trackingType: this.trackingValue,
        }))
      );
    }
  }

  calorieTrackingEmitted(): void {
    let message = '';
    if (this.goalValue > this.mealPlanCalories) {
      message = `La calorías del plan alimenticio están ${Math.trunc(this.goalValue - this.mealPlanCalories)} kcal por debajo de lo deseado.`;
    } else {
      message = `La calorías del plan alimenticio están ${Math.trunc(this.mealPlanCalories - this.goalValue)} kcal por encima de lo deseado.`;
    }
    const obj: Partial<ICalorieTracking> = {
      calories: this.goalValue,
      message,
      measurementCalories: 0,
      mealPlanCalories: this.mealPlanCalories,
      caloriesAdded: 0,
      type: this.measurementType,
      trackingType: this.trackingValue
    };
    this.changeCalories.emit(obj);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.mealPlanCalories) {
      this.onChange().then();
    }
  }

  /**
   * Get calorie tracking value
   */
  getCalcCalorieTracking(): number {
    return this.goalValue;
  }


  ngOnDestroy(): void {
    this.activeObservables = false;
  }

}
